import moment from "moment";

/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'FloorplanFilterService'; // jshint ignore:line

/**
 * Description:
 * Helper functions for floorplan filtering.
 * Gets loaded as part of 'floorplan' module.
 *
 * External dependencies:
 * - moment
 * - underscore
 */

export default function FloorplanFilterService(PlanConst) {
  "ngInject";

  const THIS_SERVICE = {
    checkIsNextLayout: checkIsNextLayout
  };

  /**
   * Checks if serviceLayout (sl) in question should be added as nextLayout on matchLayout
   */
  function checkIsNextLayout(filterServices, scheduleServices, sl, matchLayout) {
    const service = scheduleServices.find(o => o._id === sl.serviceId);
    const duration = (service && service.bookingDuration) ? service.bookingDuration : PlanConst.Bookings.duration;
    const usesSameLayout = sl.layoutId === matchLayout.layoutId;
    return usesSameLayout &&
      !_isSL1StartingBeforeSL2Ends(sl, matchLayout) &&
      _getTimeBetweenSL1StartAndSL2End(sl, matchLayout) <= duration &&
      _checkFiltersContainService(filterServices, sl.serviceId) &&
      _checkFiltersContainSection(filterServices, sl.sectionId);
  }

  /**
   * PRIVATE FUNCTIONS BELOW HERE
   */

  /**
   * Returns true if 'service layout 1' starts before 'service layout 2' ends.
   * For example: Does 'private party' start before 'Dinner' ends.
   */
  function _isSL1StartingBeforeSL2Ends(serviceLayout1, serviceLayout2) {
    return moment(serviceLayout1.startTime).isBefore(moment(serviceLayout2.endTime));
  }

  /**
   * Returns the time (in mins) between when serviceLayout1 starts and serviceLayout2 ends.
   */
  function _getTimeBetweenSL1StartAndSL2End(serviceLayout1, serviceLayout2) {
    return Math.ceil(moment.duration(moment(serviceLayout1.startTime).diff(moment(serviceLayout2.endTime))).asMinutes());
  }

  /**
   * checks if filters contain a service by id
   */
  function _checkFiltersContainService(filterServices, serviceId) {
    return _.size(filterServices) === 0 || filterServices.find(o => o._id === serviceId);
  }

  /**
   * checks if filters contain a section by id
   */
  function _checkFiltersContainSection(filterSections, sectionId) {
    return _.size(filterSections) === 0 || _.contains(filterSections, sectionId);
  }


  /**
   * Return this service
   */
  return THIS_SERVICE;
}
